import { Box, styled } from "@mui/material";

const CreateEntityBox = styled(Box)({
    border: '1px solid rgba(88, 106, 132, 0.25)',
    boxShadow: '0px -1px 20px 1px rgba(64, 82, 137, 0.25)',
    borderRadius: '6px',
    maxWidth: '100%',
    margin: '0 20px',
    textAlign: 'center',
    // minHeight: '437px',
    padding: '30px 20px',
    display: 'grid',
    gap: '20px'
  });

  export default CreateEntityBox;